import { useEffect, useState } from 'react';
import InputDate from './inputDate';

interface DateRangeFilterProps {
    cssClasses?: string;
    onFilterChange: (fromDate: string, toDate: string) => void;
    resetTrigger: boolean;
    fromDate?: string;
    toDate?: string;
    minDate?: string;
    maxDate?: string;
}

const DateRangeFilter = ({
    onFilterChange,
    cssClasses = "",
    resetTrigger,
    fromDate: defaultFrom,
    toDate: defaultTo,
    minDate,
    maxDate,
}: DateRangeFilterProps) => {
    const [fromDate, setFromDate] = useState<string>(defaultFrom ?? '');
    const [toDate, setToDate] = useState<string>(defaultTo ?? '');

    useEffect(() => {
        setFromDate(defaultFrom ?? '');
        setToDate(defaultTo ?? '');
    }, [defaultFrom, defaultTo]);

    useEffect(() => {
        if (resetTrigger) {
            setFromDate(defaultFrom ?? '');
            setToDate(defaultTo ?? '');
        }
    }, [resetTrigger, defaultFrom, defaultTo]);

    const handleFromDateChange = (name: string, value: string) => {
        console.log(name);
        setFromDate(value);
        onFilterChange(value, toDate);
    };

    const handleToDateChange = (name: string, value: string) => {
        console.log(name);
        setToDate(value);
        onFilterChange(fromDate, value);
    };

    return (
        <div className={`date-range-filter ${cssClasses}`}>
            <InputDate
                name="fromDate"
                label="From"
                value={fromDate}
                onChange={handleFromDateChange}
                min={minDate}
                max={maxDate}
            />
            <InputDate
                name="toDate"
                label="To"
                value={toDate}
                onChange={handleToDateChange}
                min={minDate}
                max={maxDate}
            />
        </div>
    );
};

export default DateRangeFilter;
